module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/browserify-sign/algos.js
// module id = ../../../../browserify-sign/algos.js
// module chunks = 4